import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-facility-request',
  templateUrl: './add-facility-request.component.html',
  styleUrls: ['./add-facility-request.component.scss']
})
export class AddFacilityRequestComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
